import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const serieApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
serieApiInstance.interceptors.request.use(requestInterceptor);

export default serieApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/serieApi.js